import type { QuestData } from '@thottbot/shared';
import { FieldTable, Money, RefLink, prose, refList, type RefView } from './FieldTable';

export function QuestFields({ data }: { data: QuestData }) {
  const rewards = data.rewards;
  return (
    <FieldTable
      rows={[
        { label: 'Level', value: data.level },
        { label: 'Requires level', value: data.minLevel },
        { label: 'Zone', value: data.zone },
        { label: 'Faction', value: data.faction },
        {
          label: 'Starts at',
          value: data.giver && <RefLink r={data.giver as RefView} fallbackType="npc" />,
        },
        {
          label: 'Ends at',
          value: data.turnIn && <RefLink r={data.turnIn as RefView} fallbackType="npc" />,
        },
        { label: 'Objectives', value: prose(data.objectives) },
        { label: 'Description', value: prose(data.description) },
        { label: 'Progress', value: prose(data.progressText) },
        { label: 'Completion', value: prose(data.completionText) },
        { label: 'Experience', value: rewards?.xp },
        { label: 'Money', value: rewards?.money ? <Money copper={rewards.money} /> : undefined },
        { label: 'Reward items', value: refList(rewards?.items, 'item') },
        { label: 'Choose one of', value: refList(rewards?.choiceItems, 'item') },
        {
          label: 'Previous quest',
          value: data.prevQuest && <RefLink r={data.prevQuest as RefView} fallbackType="quest" />,
        },
        {
          label: 'Next quest',
          value: data.nextQuest && <RefLink r={data.nextQuest as RefView} fallbackType="quest" />,
        },
      ]}
    />
  );
}
